import type { PropsWithChildren } from 'react';
import type React from 'react';

import { Box, InlineFeedback, List, Text } from '@zillow/constellation-10';

type Props = {
  needsInfo?: boolean;
  associatedNodeId: number;
  getLeasingStatusForNode(event: React.SyntheticEvent<HTMLSpanElement>): void;
};

export default function SummaryItem({ needsInfo, children }: PropsWithChildren<Props>): JSX.Element {
  return (
    <List.Item css={{ paddingTop: 0, paddingBottom: 0 }}>
      <Box css={{ display: 'flex', alignItems: 'center' }}>
        {children || needsInfo ? (
          <Text data-test="children" css={{ textStyle: 'body-sm', whiteSpace: 'pre-line' }}>
            {children}
          </Text>
        ) : (
          <Box css={{ marginBottom: 'tight' }} />
        )}
        {needsInfo && <InlineFeedback tone="warning">Needs info</InlineFeedback>}
      </Box>
    </List.Item>
  );
}
